export const CREATE_CAMPAIGN_FORM_STEPS = [
    'Sending to',
    'Select template',
    'Schedule email'
];